import { Box, Flex, Text, useColorModeValue, VStack } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

interface PanelProps {
  heading?: string | ReactNode
  subheading?: string
  padding?: string | number,
  className?: string,
  children: ReactNode
  action?: ReactNode
  transparent?: boolean
}

export const Panel: FC<PanelProps> = ({ heading, subheading, children, padding, action, className, transparent }) => {
  const textColor = useColorModeValue('#1A202C', 'white');
  const bgColor = useColorModeValue('white', 'rgba(255,255,255,0.05)');
  return (
    <VStack align="stretch" spacing={6}>
      {heading || action && (
        <Flex justifyContent='space-between' direction='row' w='100%' className='remove-gutter-print'>
          <Flex justifyContent='space-between' direction='column'>
            {!subheading ? null : (
              <Text mt='20px' color={textColor} fontSize='22px' fontWeight='700' lineHeight='100%'>
                {heading}
              </Text>
            )}
            {!subheading ? null : (
              <Text color={textColor} mt={'12px'} fontSize='14px' fontWeight='400' lineHeight='100%'>
                {subheading}
              </Text>
            )}
          </Flex>
          {!action ? null : action}
        </Flex>
      )}
      <Box flexDirection='column' w='100%' px='0px' className={'remove-gutter-print ' + className} background={transparent ? 'transparent' : bgColor} border={transparent ? 'none' : "1px solid"} borderColor={transparent ? 'transparent' : useColorModeValue("gray.200", "gray.700")}
        borderRadius="8px"
        boxShadow="none"
        transition="border-color 0.2s">
        <Box px={padding || '0px'} py={padding || '0px'}>{children}</Box>
      </Box>
    </VStack>

  )
}

export const PanelWithTabs: FC<PanelProps> = ({ children }) => (
  <Box flexDirection='column' w='100%' px='0px' py='5px' overflowX={{ sm: 'scroll', lg: 'hidden' }} className='remove-gutter-print'>
    {children}
  </Box>
)
